'use strict';

const selfHost = process.env.VUE_APP_SELF_HOST;
const selfPort = process.env.VUE_APP_SELF_PORT;
const appHost = process.env.VUE_APP_PRODUCT_HOST;
const appPort = process.env.VUE_APP_PRODUCT_PORT;
const resourceHost = process.env.VUE_APP_RESOURCE_HOST;
const resourcePort = process.env.VUE_APP_RESOURCE_PORT;
const isProduction = process.env.VUE_APP_ENV !== 'dev';

const siteTitle = '印刷工場のための深層学習モデル作成ツール POODL プードル';

class Host {
  constructor(host, port) {
    this.host = host;
    this.port = port;
    this.url = this.combineUrl(this.host, this.port);
  }

  combineUrl(host, port) {
    return port == 80 ? host : host + ':' + port;
  }
}

class Connect {
  constructor(self, app, resource) {
    this.self = self;
    this.app = app;
    this.resource = resource;
  }
}

const dev = new Connect(
  new Host(
    selfHost ? selfHost : 'http://localhost',
    selfPort ? selfPort : 8080
  ),
  new Host(appHost ? appHost : 'http://localhost', appPort ? appPort : 8089),
  new Host(
    resourceHost ? resourceHost : 'http://localhost',
    resourcePort ? resourcePort : 8030
  ),
);
const build = new Connect(
  new Host(
    selfHost ? selfHost : 'https://poodl.cloud',
    selfPort ? selfPort : 80
  ),
  new Host(
    appHost ? appHost : 'https://app.poodl.cloud',
    appPort ? appPort : 80
  ),
  new Host(
    resourceHost ? resourceHost : 'https://poodl.cloud',
    resourcePort ? resourcePort : 80
  ),
);

const Config = {
  isProduction: isProduction,
  dev: dev,
  build: build,
  siteTitle: siteTitle,
  host: isProduction ? build.self.host : dev.self.host,
  port: isProduction ? build.self.port : dev.self.port,
  url: isProduction ? build.self.url : dev.self.url,
  appHost: isProduction ? build.app.host : dev.app.host,
  appPort: isProduction ? build.app.port : dev.app.port,
  appUrl: isProduction ? build.app.url : dev.app.url,
  resourceHost: isProduction ? build.resource.host : dev.resource.host,
  resourcePort: isProduction ? build.resource.port : dev.resource.port,
  resourceUrl: isProduction ? build.resource.url : dev.resource.url,
};

export default Config;
